import { getCalendarSearchStore } from 'owa-calendar-search-store';

export default function getSelectedSearchScopeDisplayName(): string {
    const calendarSearchStore = getCalendarSearchStore();
    return calendarSearchStore.accountSmtpAddress;
}
